import { useState, useEffect } from "react";
import { onConnectivityChange, getApiOnline } from "@/lib/api";

// Shared app-level connectivity hook. API request success/failure is authoritative;
// navigator online/offline events are immediate hints.
export function useConnectivity() {
  const [online, setOnline] = useState(() => getApiOnline() && (typeof navigator === "undefined" || navigator.onLine !== false));

  useEffect(() => {
    const off = onConnectivityChange((v) => setOnline(v));
    const goOffline = () => setOnline(false);
    const goOnline = () => setOnline(true); // optimistic; a failing refetch will flip it back
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => { off(); window.removeEventListener("offline", goOffline); window.removeEventListener("online", goOnline); };
  }, []);

  return online;
}
